import { api, extractJsonObject } from "./api";

function toJson(respData) {
  if (typeof respData === "object") return respData;
  const cleaned = extractJsonObject(respData);
  return JSON.parse(cleaned);
}

export async function checkMobileExists(mobile) {
  const body = new URLSearchParams();
  body.append("mobile", mobile);

  const resp = await api.post("check_mobilemd.php", body, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });

  const j = toJson(resp.data);
  return !!j.exists;
}

export async function sendOtpApi(mobno, otp) {
  const m = String(mobno).replace(/\D+/g, ""); // digits only (important)
  const o = String(otp).trim();

  const body = new URLSearchParams();
  body.append("mobno", m);
  body.append("otp", o);

  try {
    const resp = await api.post("sendotpmd.php", body.toString(), {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });

    console.log("sendotpmd.php status:", resp.status);
    console.log("sendotpmd.php response:", resp.data);

    // Android treats any 200 as success (it doesn't parse JSON)
    return { ok: true, data: resp.data };
  } catch (err) {
    console.error("sendotpmd.php ERROR:", err);

    const status = err?.response?.status;
    const data = err?.response?.data;

    console.error("sendotpmd.php ERROR status:", status);
    console.error("sendotpmd.php ERROR response:", data);

    return { ok: false, status, data };
  }
}

export async function registerKendraApi({
  firstName,
  lastName,
  mobile,
  newPass,
  enname,
  city,
  tal,
  dist,
  state,
}) {
  const body = new URLSearchParams();
  body.append("first_name", firstName);
  body.append("last_name", lastName);
  body.append("mobile", mobile);
  body.append("new_pass", newPass);
  body.append("enname", enname);
  body.append("city", city);
  body.append("tal", tal);
  body.append("dist", dist);
  body.append("state", state);

  const resp = await api.post("add_newregit.php", body, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });

  const j = toJson(resp.data);
  return j; // { ok: true/false, error?: "" }
}
